<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="ma-auto">
        <v-card
          :loading="loading"
          class="ma-auto mt-15"
          max-width="374"
          min-width="374"
        >
          <template slot="progress">
            <v-progress-linear
              color="blue"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <v-card-title>Inicia Sesión</v-card-title>

          <v-card-text>
            <v-form v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="Correo Electrónico"
                      required
                      autocomplete
                      autofocus
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="password"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[passwordRules.required, passwordRules.min]"
                      :type="show ? 'text' : 'password'"
                      name="input-10-1"
                      label="Contraseña"
                      hint="At least 8 characters"
                      counter
                      @click:append="show = !show"
                      autocomplete
                      @keydown.enter="getAuthentication"
                      :autofocus="autofocus"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn color="grey" text @click="cancel">
              Cancelar
            </v-btn>
            <v-btn
              color="blue lighten-2"
              text
              @click="getAuthentication"
              :disabled="!valid"
            >
              Inciar Sesión
            </v-btn>
          </v-card-actions>
          <v-snackbar v-model="alertSnackbar" :timeout="3000" top>
            {{ snackbarText }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="blue"
                text
                v-bind="attrs"
                @click="alertSnackbar = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { Config } from "../config";
export default {
  data: () => ({
    autofocus: false,
    loading: false,
    selection: 1,
    email: "",
    emailRules: [
      v => !!v || "El correo electrónico es necesario",
      v => /.+@.+/.test(v) || "El correo electrónico debe ser válido"
    ],
    password: "",
    passwordRules: {
      required: value => !!value || "La contraseña es necesaria",
      min: v => v.length >= 8 || "Mínimo 8 caracteres",
      emailMatch: () => `Correo y/o contraseña es inválida`
    },
    show: false,
    valid: false,
    snackbarText: "",
    alertSnackbar: false
  }),
  mounted() {
    setTimeout(() => {
      this.autofocus = true;
    }, 500);
  },
  computed: {},
  methods: {
    reserve() {
      this.loading = !this.loading;
    },
    cancel() {
      this.password = "";
      this.email = "";
    },
    getAuthentication() {
      if (this.valid) {
        this.loading = true;
        let url = `${Config.url}/login_handler`;
        const FormData = require("form-data");
        const form = new FormData();
        form.append("username", this.email);
        form.append("password", this.password);
        this.axios
          .post(url, form, { withCredentials: true })
          .then(res => {
            if (res.status == 200) {
              this.getUserAuth();
            }
          })
          .catch(err => {
            if (err.response.status == 401) {
              this.snackbarText = `Uno o ambos datos son incorrectos`;
              this.password = "";
            } else {
              this.snackbarText =
                "Ocurrió un error al autenticarse, intente más tarde";
            }
            this.alertSnackbar = true;
          })
          .finally(() => {
            this.overlay = false;
            this.loading = false;
          });
      }
    },
    getUserAuth() {
      let url = `${Config.url}/db/user/${this.email}`;
      this.axios
        .get(url)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            let user = res.data;
            localStorage.setItem("userAuth", JSON.stringify(user));
            window.location.replace("/falcon");
          }
        })
        .catch(err => {
          if (err.response.status == 401) {
            this.snackbarText = `Uno o ambos datos son incorrectos`;
          } else {
            this.snackbarText =
              "Ocurrió un error al autenticarse, intente más tarde";
          }
          this.alertSnackbar = true;
        })
        .finally(() => {
          this.overlay = false;
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
